import { Link } from 'react-router-dom';
import StoryCard from '@/components/feature/StoryCard';
import { categories, siteInfo } from '@/mocks/categories';
import { stories } from '@/mocks/stories';

interface SidebarProps {
  activeCategory: string;
  onSelectCategory: (slug: string) => void;
}

export default function StoriesSidebar({ activeCategory, onSelectCategory }: SidebarProps) {
  const popular = [...stories].sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">内容分类</h3>
        <ul className="mt-4 space-y-1.5">
          <li>
            <button
              type="button"
              onClick={() => onSelectCategory('all')}
              className={`flex w-full items-center justify-between rounded-md px-3 py-2.5 text-sm transition-colors ${
                activeCategory === 'all'
                  ? 'bg-primary-50 font-medium text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              <span>全部趣闻</span>
              <span className="text-xs text-foreground-500">{stories.length}</span>
            </button>
          </li>
          {categories.map((cat) => {
            const count = stories.filter((s) => s.categorySlug === cat.slug).length;
            const active = activeCategory === cat.slug;
            return (
              <li key={cat.slug}>
                <button
                  type="button"
                  onClick={() => onSelectCategory(cat.slug)}
                  className={`flex w-full items-center justify-between rounded-md px-3 py-2.5 text-sm transition-colors ${
                    active ? 'bg-primary-50 font-medium text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <i className={`${cat.icon} ${active ? 'text-primary-600' : 'text-foreground-500'}`} />
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500">{count}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-line text-primary-500" />
          本周热读
        </h3>
        <div className="mt-2">
          {popular.map((story, i) => (
            <StoryCard key={story.id} story={story} variant="compact" index={i} />
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-accent-50 p-5">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-quill-pen-line text-lg" />
        </span>
        <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">也想讲讲你的故事？</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          投稿邮箱长期开放，附上时间、场景和感受即可，编辑会在一周内回复。
        </p>
        <a
          href={`mailto:${siteInfo.submitEmail}`}
          className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
        >
          <i className="ri-mail-send-line" />
          去投稿
        </a>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
        <h3 className="font-heading text-base font-bold text-foreground-950">拉上室友一起看</h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          把瓜田笔记分享给同学，看看你们对同一件事的反应是不是也一样。
        </p>
        <div className="mt-4 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-600">
            <i className="ri-wechat-line" />
          </span>
          <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-600">
            <i className="ri-weibo-line" />
          </span>
          <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-600">
            <i className="ri-link" />
          </span>
        </div>
      </div>
    </aside>
  );
}